import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, setAccessToken, formatApiError } from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined); // undefined=loading, null=anon, obj=auth
  const [merchant, setMerchant] = useState(null);
  const [wallet, setWallet] = useState(null);
  const [env, setEnv] = useState({
    environment: "development",
    enable_dev_otp: true,
    sms_provider_configured: false,
  });

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data.user);
      setMerchant(data.merchant || null);
      setWallet(data.wallet || null);
      return data;
    } catch {
      setUser(null);
      setMerchant(null);
      setWallet(null);
      return null;
    }
  }, []);

  useEffect(() => {
    refresh();
    api
      .get("/info/environment")
      .then(({ data }) => setEnv(data))
      .catch(() => {});
  }, [refresh]);

  const login = async (identifier, password) => {
    const { data } = await api.post("/auth/login", { identifier, password });
    setAccessToken(data.access_token);
    await refresh();
    return data.user;
  };

  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    setAccessToken(data.access_token);
    await refresh();
    return data.user;
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch {}
    setAccessToken(null);
    setUser(null);
    setMerchant(null);
    setWallet(null);
  };

  return (
    <AuthCtx.Provider value={{ user, merchant, wallet, env, login, register, logout, refresh, formatApiError }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
